import { useEffect } from "react";

// Smart API URL: dev vs prod
export const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3300"
    : `${window.location.origin}/accountsync-api`;

const XeroSignupRedirect = () => {
  useEffect(() => {
    const loginType = "xero";
    const tenantId = 1; 

    window.location.href = `${API_URL}/singleSignOn?loginType=${loginType}&tenantId=${tenantId}`;
  }, []);

  return <p>Redirecting to Xero...</p>;
};

export default XeroSignupRedirect;
